export function defaultHeaderOptionsFunction() {
  let defaultHeaderOptions = {};
  if(typeof connectspace_config != "undefined") {
    defaultHeaderOptions = {
      "Content-Type": "application/json",
      "X-Notefit-Account-Api-Auth-Token": connectspace_config.api_auth_token
    };
  } else {
    defaultHeaderOptions = {
      "Content-Type": "application/json",
      "X-Notefit-Planner-Api-Auth-Token": notefit_config.api_auth_token,
      "X-Notefit-Team-Api-Auth-Token": notefit_config.team_api_auth_token
    };
  }
  return defaultHeaderOptions;
}
